import React, { useState, useEffect } from "react";

interface FadeInTextProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Componente que muestra contenido con animación fade-in suave
 * Aparece todo el contenido al mismo tiempo con un efecto delicado
 */
const FadeInText: React.FC<FadeInTextProps> = ({
  children,
  className = "",
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Pequeño delay para permitir que el componente se monte antes de la animación
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={`transition-all duration-1000 ease-in-out ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"
      } ${className}`}
    >
      {children}
    </div>
  );
};

export default FadeInText;
